import React, { useCallback, useState } from 'react';
import Radio from '@active/react-ui/Radio';
import RadioGroup from '@active/react-ui/RadioGroup';
import FormGroup from '@active/react-ui/FormGroup';
import FormField from '@active/react-ui/FormField';
import Locale from '@active/react-utils/i18n/Locale';
import FormLabel from '@active/react-ui/FormLabel';
import classNames from 'classnames';
import isNil from 'lodash/isNil';
import { interpolate } from '../../../../../../../../../shared/utils/commonUtils';

const MASK = '****';
const SavedAccount = ({ savedAccounts = [], toggleCreateAccount, labelForEcheckNewAccount }) => {
  const [ selectedAccount, setSelectedAccount ] = useState(savedAccounts[0]?.id ?? 'addECheck');

  const radioChange = useCallback((values) => {
    const { target: { value } } = values;
    setSelectedAccount(value);
    toggleCreateAccount(values);
  }, [ toggleCreateAccount ]);

  return (<div className="saved-account">
    <FormGroup name="selectedAccount">
      <FormLabel className="hidden-label"/>
      <FormField
        as={RadioGroup}
        onChange={radioChange}>
        {
          savedAccounts.map(({ id, maskedNumber }, index) => {
            return <Radio key={index} value={id} className={classNames('saved-item', {
              active: selectedAccount === id,
            })}>
              <span className="ic-e-check saved-item-icon" />
              <span>
                {
                  interpolate(maskedNumber, { mask: MASK })
                }
              </span>
            </Radio>;
          })
        }
        <Radio className={classNames('add-new-account', {
          active: selectedAccount === 'addECheck',
        })} value="addECheck" role="radio">
          {
            isNil(labelForEcheckNewAccount)
              ? <Locale id="checkout.lib.components.payment.echeck.add.title" />
              : labelForEcheckNewAccount
          }
        </Radio>
      </FormField>
    </FormGroup>
  </div>);
};

export default SavedAccount;
